<template>
  <div class="product-selector">
    <section ref="price" class="price" v-show="!isdistcountry" v-if="selectedProduct.length < 1">
      <span v-show="allProducts.length > 1 && !hasSinglePrice">Starting at<br /></span>
      {{ `$${lowestPrice}` }}
    </section>

    <section ref="price" class="price" v-show="!isdistcountry" v-else-if="selectedProduct.length === 1">
      {{ `$${selectedProduct[0].price}` }}
    </section>

    <FSAHSA v-show="!isdistcountry && fsahsa" />

    <section ref="price" class="price" v-show="isdistcountry">
      <p style="font-size:0.9375rem; font-weight:700; font-family:Roboto, sans-serif;">Please contact your local representative for pricing.</p>
    </section>

    <section ref="affirm" v-show="!isdistcountry && lowestPrice >= 100">
      <p class="part-number affirm-as-low-as" data-page-type="product" :data-amount="`${lowestPrice}00`">.<br/>Consumer financing in the USA only.</p>
      <p class="part-number">Interested in <a href="https://www.pilates.com/commercial-financing/" target="_blank">commercial financing</a> for your business purchases?</p>
      <p v-if="additionalText" class="part-number">{{ additionalText }}</p>
    </section>

    <section v-show="lowestPrice < 100">
      <p v-if="additionalText" class="part-number">{{ additionalText }}</p>
    </section>

    <section
      class="part-number"
      v-if="selectedProduct.length !== 0"
    >
      Part #: {{ selectedProduct[0].partnumber }}
      &nbsp;|&nbsp;
      Price: {{ `$${selectedProduct[0].price}` }}
    </section>

    <section
      class="part-number"
      v-if="product.value === 'Contrology Wall Tower'"
    >
      Part #: 18746
      &nbsp;|&nbsp;
      Price: $1850
    </section>

    <div ref="addToCart" v-show="!isdistcountry" class="add-to-cart">
      <div class="select-fields">
        <div class="cta-select">
          <select v-model="product.value" aria-label="select">
            <option disabled>{{ product.label }}</option>
            <option
              v-for="(product, index) in allProducts"
              :key="index"
            >
              {{ product }}
            </option>
          </select>
        </div>
        
        <div class="cta-select" v-show="option1.value && product.value.search('Select') === -1 && product.value !== 'Contrology Wall Tower'">
          <select v-model="option1.value" aria-label="select">
            <option disabled>{{ option1.label }}</option>
            <option
              v-for="(option, index) in allOptions1"
              :key="index"
            >
              {{ option }}
            </option>
          </select>
        </div>

        <div class="cta-select" v-show="option2.value && option1.value.search('Select') === -1">
          <select v-model="option2.value" aria-label="select">
            <option disabled>{{ option2.label }}</option>
            <option
              v-for="(option, index) in allOptions2"
              :key="index"
            >
              {{ option }}
            </option>
          </select>
        </div>
      </div>

      <cta-cart-button v-show="product.value !== 'Contrology Wall Tower'"
        :prodid="selectedProduct.length !== 0 ? selectedProduct[0].prodid : ''"
        :active="selectedProduct.length !== 0 && selectedProduct[0].available"
        cta="Add to Cart"
      />
      <cta-cart-button v-show="product.value === 'Contrology Wall Tower'"
        :prodid="48870362153153"
        :active=true
        cta="Add to Cart"
      />
    </div>

    <slot></slot>

    <section
      class="product-message"
      v-if="selectedProduct.length !== 0 && !selectedProduct[0].available"
    >
      <p class="extra-content"><img src="@/assets/icon-alert.svg" alt="Alert icon" /> <b>* To order, please call us at (916) 388-2838 or send us an <a href="mailto:info@pilates.com">email</a>.</b></p>
    </section>
  </div>
</template>

<script>
  import CtaCartButton from "@/components/CtaCartButton.vue";
  import FSAHSA from "@/components/FSAHSA.vue";

  export default {
    name: "productselector",

    props: {
      products: Array,
      product: Object,
      option1: Object,
      option2: Object,
      isdistcountry: Boolean,
      additionalText: String,
      fsahsa: Boolean
    },

    components: {
      CtaCartButton,
      FSAHSA
    },

    computed: {
      selectedProduct() {
        const key = this.product.key;
        const key1 = this.option1.key;
        const key2 = this.option2.key;
        return this.products.filter( ( product ) => {
          console.log(product[key], this.product.value, product[key1], this.option1.value, product[key2], this.option2.value);
          return ( product[key] === this.product.value && product[key1] === this.option1.value && product[key2] === this.option2.value);
        });
      },

      allProducts() {
        const key = this.product.key;
        return [...new Set(this.products.map( product => product[key] ))];
      },

      allOptions1() {
        const productKey = this.product.key;
        const optionKey = this.option1.key;
        const filteredProducts = this.products.filter( ( item ) => {
          return ( item[productKey] === this.product.value)
        })
        return [...new Set(filteredProducts.map( product => product[optionKey]))];
      },

      allOptions2() {
        const key = this.option2.key;
        return [...new Set(this.products.map( product => product[key]))];
      },

      lowestPrice() {
        const result = this.products.reduce(function(res, obj) {
          return (obj.price < res.price) ? obj : res;
        });
        return result.price;
      },

      hasSinglePrice() {
        const price = this.products[0].price;
        let result = this.products.every( (product) => {
          return product.price === price;
        });
        return result;
      }
    },

    mounted() {
      this.initSelectLabels()

      window.affirm.ui.ready(function(){
        window.affirm.ui.refresh();
      });
    },

    methods: {
      initSelectLabels() {
        this.product.value = this.product.label;
        this.option1.value = this.option1.label;
        this.option2.value = this.option2.label;
      }
    }
  }
</script>

<style lang="scss" scoped>
.price span {
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
}

.price {
  font-family: var(--noto);
  font-size: 1.625rem;
  line-height: 1.192;
  color: var(--black);
}

.part-number {
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin: 15px 0 0;
}

.cta-select {
  font-family: var(--roboto);
  font-weight: 400;
  color: var(--black);
  margin: 15px 0;
  border: 1px solid var(--black);
  background-color: transparent;
  width: 100%;
  height: 56px;
  margin-right: 10px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  padding-left: 10px;
}

.cta-select:after {
  position: absolute;
  content: "";
  top: 43%;
  right: 10px;
  width: 0;
  height: 0;
  border: 9px solid transparent;
  border-color: var(--black) transparent transparent transparent;
  z-index: -1;
}

.cta-select select {
  padding: 17px 8px;
  font-size: 0.9375rem;
  width: 100%;
  border: none;
  box-shadow: none;
  background-color: transparent;
  background-image: none;
  appearance: none;
  cursor: pointer;
}

.cta-select select:focus {
  outline: none;
}

.product-message {
  margin-bottom: 0;
}

p.extra-content {
  margin: 0;
}

p.extra-content b {
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
}

p.intro {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
  margin: 0 0 10px;
}

@media only screen and (min-width: 768px) {
  .add-to-cart {
    display: flex;
  }

  .select-fields {
    flex-grow: 1;
  }

  .cta-select {
    width: 95%;
    height: 45px;
    display: flex;
    align-items: center;
  }

  .btn-wrapper-black {
    width: 145px;
    height: 45px;
  }
}

@media only screen and (min-width: 1024px) {
  .product-selector {
    order: 2;
  }

  .add-to-cart {
    display: flex;
    flex-flow: column nowrap;
  }

  .cta-select {
    width: 340px;
    margin-bottom: 8px;
  }

  .btn-wrapper-black {
    margin: 0 0 25px 0;
    width: 340px;
    align-self: flex-start;
  }

  .extra-content {
    margin-bottom: 20px;
  }
}

@media only screen and (min-width: 1208px) {
  .add-to-cart {
    flex-flow: row nowrap;
    align-items: center;
  }

  .cta-select {
    margin-bottom: 15px;
    width: 95%;
  }

  .btn-wrapper-black {
    margin: 15px 0;
    width: 145px;
  }

  .extra-content {
    margin-bottom: 0;
  }
}
</style>